import { MESSENGERS } from '@mssgme/constants';
import { get } from 'lodash';

// TODO: remove this formatter, do simpler
export default (value, format, locale) => {
    if (format === 'platform') {
        return get(MESSENGERS, `${value}.label`, value.toUpperCase());
    }
};
